import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { dotDangKyNganh2Api } from "../../../api/quan-ly-nganh-2/dotDangKyNganh2Api";
import { rootActions } from "../../actions/rootActions";
import { eDotDangKyNganh2ActionIds, IDotDangKyNganh2ActionTypes } from "../../action-types/quan-ly-nganh-2/IDotDangKyNganh2Actions";
import { IDotDangKyNganh2 } from "../../../model/response/quan-ly-nganh-2/IDotDangKyNganh2";

export function* dotDangKyNganh2Saga(): any {
    yield takeLatest(eDotDangKyNganh2ActionIds.LOAD_START, loadWorker);
    yield takeEvery(eDotDangKyNganh2ActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDotDangKyNganh2ActionIds.DELETE_START, deleteWorker);
}

function* loadWorker() : any {
    const res: IBaseResponse = yield call(dotDangKyNganh2Api.SelectAll);
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.LOAD_ERROR(res.message ?? "Có lỗi khi tải đợt đăng ký ngành 2"));
    }
}

function* saveWorker(action: IDotDangKyNganh2ActionTypes): any {
    const payload = action.payload as IDotDangKyNganh2;
    let res: IBaseResponse;
    if (payload.id_dot_dang_ky > 0) {
        res = yield call(dotDangKyNganh2Api.Update, payload.id_dot_dang_ky, payload);
    } else {
        res = yield call(dotDangKyNganh2Api.Insert, payload);
    }
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.SAVE_SUCCESS(res.data));
    } else {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.SAVE_ERROR(res.message ?? "Có lỗi khi lưu đợt đăng ký ngành 2"));
    }
}

function* deleteWorker(action: IDotDangKyNganh2ActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(dotDangKyNganh2Api.Delete, id);
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.DELETE_SUCCESS(res.data));
    } else {
        yield put(rootActions.quanLyNganh2.dotDangKyNganh2.DELETE_ERROR(res.message ?? "Có lỗi khi xóa đợt đăng ký ngành 2"));
    }
}